// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3cf52d88]{display:none}.labeled-link-standard[data-v-3cf52d88]{background-position:50%;background-repeat:no-repeat;background-size:auto auto;background-size:initial;background-size:var(--labeled-link-standart-bg-size,initial);display:inline-block;filter:var(--c-svg-white-filter);height:23px;height:var(--labeled-link-standart-height,23px);width:23px;width:var(--labeled-link-standart-width,23px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
